// import * as icons from "@material-ui/icons";
import { Paper } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Table, TableBody, TableCell, TableHead, TableRow } from '../../../components/Table';
import { fetchJobDetailRequest } from '../../../store/actions/jobs';
import { IJob, IJobsState } from '../../../store/types/job';

class JobDetail extends React.Component<any, any> {
  public componentDidMount() {
    this.props.fetchJob(this.props.match.params.jobId);
  }

  public render() {
    const job = this.props.jobDetail as IJob;

    if (!job || !job.applications || !job.applications.length) {
      return <p>No data!</p>;
    }

    return (
      <>
        <Paper className="JobDetail">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell numeric={true}>ID</TableCell>
                <TableCell>Candidate ID</TableCell>
                <TableCell>Candidate</TableCell>
                <TableCell>Platform</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Created</TableCell>
                <TableCell>Called (length)</TableCell>
                <TableCell>Resolved</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {job.applications.map(r => {
                return (
                  <TableRow key={r.id} hover={true}>
                    <TableCell numeric={true}>{r.id}</TableCell>
                    <TableCell numeric={true}>{r.candidate_id}</TableCell>
                    <TableCell>
                      {r.candidate
                        ? `${r.candidate.given_name} ${r.candidate.family_name}`
                        : r.candidate_id}
                    </TableCell>
                    <TableCell>{r.candidate ? r.candidate.platform : null}</TableCell>
                    <TableCell>{r.status}</TableCell>
                    <TableCell>{new Date(r.created_at).toLocaleString('cs-CZ')}</TableCell>
                    <TableCell>
                      {new Date(r.called_at).toLocaleString('cs-CZ')} ({r.call_length} s)
                    </TableCell>
                    <TableCell>{new Date(r.reacted_at).toLocaleString('cs-CZ')}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Paper>
      </>
    );
  }
}

const mapStateToProps = (state: { jobs: IJobsState }) => {
  return {
    jobDetail: state.jobs.detail,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    fetchJob: (id: number) => dispatch(fetchJobDetailRequest(id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JobDetail);



// WEBPACK FOOTER //
// ./src/screens/Jobs/JobDetail/JobDetail.tsx